import { jsx, jsxs } from "react/jsx-runtime";
import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  Checkbox as MuiCheckbox
} from "@mui/material";
import { useTidalFormBridge } from "../../utils/useTidalFormBridge.js";
const defaultComponentValue = false;
function Checkbox(props) {
  const {
    checkboxProps = {},
    formControlLabelProps = {},
    initialValue = defaultComponentValue,
    validateOn = "change",
    ...bridgeOptions
  } = props;
  const {
    config: { fullWidth, label, name, testId = "checkbox-root" },
    fieldInfo: {
      errorOrHelperText,
      field: { required, visible },
      fieldDisabled,
      fieldHasError,
      onBlur,
      onChange,
      onFocus,
      showHelperText,
      value
    }
  } = useTidalFormBridge({
    ...bridgeOptions,
    validateOn,
    initialValue
  });
  if (!visible) return null;
  const handleOnChange = (_, checked) => {
    onChange(checked);
  };
  return /* @__PURE__ */ jsxs(
    FormControl,
    {
      error: fieldHasError,
      component: "fieldset",
      variant: "standard",
      fullWidth,
      "data-testid": testId,
      "data-tidal": "Checkbox",
      required,
      "data-tidal-form-field-name": bridgeOptions.name,
      sx: {
        "&.tidal-form-devtool-highlight": (theme) => ({
          outline: `4px solid var(--tidal-devtools-highlight-color, ${theme.vars.palette.error.dark})`
        })
      },
      children: [
        /* @__PURE__ */ jsx(
          FormControlLabel,
          {
            label,
            ...formControlLabelProps,
            name,
            onBlur,
            onFocus,
            control: /* @__PURE__ */ jsx(MuiCheckbox, { ...checkboxProps, checked: value }),
            onChange: handleOnChange,
            disabled: fieldDisabled,
            required
          }
        ),
        showHelperText && /* @__PURE__ */ jsx(FormHelperText, { error: fieldHasError, children: errorOrHelperText })
      ]
    }
  );
}
export {
  Checkbox
};
//# sourceMappingURL=Checkbox.js.map
